import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { ConnectionCount } from "src/types/apps";

import { useGetApp } from "../../AppSettings/Details/hook/useGetApp";
import Context from "../context";

export default function useDataChart() {
	const { product } = useContext(Context);

	const app = useGetApp();

	const { data: connectionsCount } = useQuery<ConnectionCount[]>({
		queryKey: [app?.id, product ? `${product}History` : "allHistory", "ALL"],
		initialData: []
	});

	const { translate } = useLocales();

	const currentYear = moment().year();
	const allMonths = moment.months();

	let resultByMonth = allMonths.map((month) => ({
		month,
		count: 0
	}));

	connectionsCount
		?.filter((item) => moment(item.date).year() === currentYear) // Filtrar solo los datos de este año
		.forEach((curr) => {
			const month = moment(curr.date).format("MMMM"); // Extraer el mes en formato de texto
			const existing = resultByMonth.find((item) => item.month === month);

			if (existing) {
				existing.count += curr.count;
			}
		});

	const series: any[] = [
		{
			type: "bar",
			name: translate("overview.month_connections"),
			data: resultByMonth.map((item) => item.count)
		}
	];

	return {
		series
	};
}
